

    import {Component, Prop, Vue} from "vue-property-decorator";

    @Component({})
export default class Part1 extends Vue {
  @Prop() data: any;
}
